import React, { Component } from 'react';
import {Route, withRouter} from 'react-router-dom';
import './reset.css';
import './App.css';

import {
  ViewLogin,
  ViewMain,
  ViewCourse,
  ViewPlayer,
  ViewWebview,
  ViewProfile,
  ViewReport,
  ViewCommerce,
  ViewBiblioteca,
  ViewLivro,
  ViewSearchCategory,
  ViewSearchTerm,
  ViewMeusDados,
  ViewSobre,
  ViewTermosDeUso,
  ViewFaleConosco,
  ViewFaq,
  ViewFavoritos,
  ViewMarcacoes,
  ViewListasDeLeitura,
  ViewBookDetail,
  ViewEsqueciMinhaSenha,
  ViewRecuperarSenha,
  ViewCadastro,
  ViewMudarSenha,
  ViewSSO,
  ViewSSOV2
} from './views';

import ReaderSettings from './components/reader-settings/reader-settings';

const RouteAnnouncer = withRouter(
  class extends Component {
    componentDidUpdate(prevProps) {
      if (this.props.location.pathname !== prevProps.location.pathname) {
        const announcer = document.getElementById('route-announcer');
        const h1 = document.querySelector('h1');
        if (announcer) {
          announcer.textContent = h1 ? `${h1.textContent} - página carregada` : 'Página carregada';
        }
        requestAnimationFrame(() => {
          const main = document.getElementById('main-content');
          if (main) {
            main.focus();
          }
        });
      }
    }
    render() {
      return null;
    }
  }
);

class App extends Component {
  render() {
    return (
      <div id="root" className="rdp-covid-19">
        <a href="#main-content" className="sr-only skip-link" tabIndex={1}>Pular para o conteúdo principal</a>
        <div id="route-announcer" aria-live="polite" className="sr-only"></div>
        <RouteAnnouncer />
        <div id="main-content" tabIndex={-1}>
          <Route exact={true} path="/" component={ViewBiblioteca}/>
          <Route exact={true} path="/login" component={ViewLogin}/>
          <Route exact={true} path="/sso/:organization/:login/:token" component={ViewSSO}/>
          <Route exact={true} path="/sso/v3/:connector/:valueType/:value/:state" component={ViewSSOV2}/>
          <Route exact={true} path="/cadastro" component={ViewCadastro}/>
          <Route exact={true} path="/user/change" component={ViewMudarSenha}/>
          <Route exact={true} path="/user/forgot" component={ViewEsqueciMinhaSenha}/>
          <Route exact={true} path="/recover-password" component={ViewRecuperarSenha}/>
          <Route exact={true} path="/perfil" component={ViewProfile}/>
          <Route exact={true} path="/user/profile" component={ViewMeusDados}/>
          <Route exact={true} path="/about" component={ViewSobre}/>
          <Route exact={true} path="/terms" component={ViewTermosDeUso}/>
          <Route exact={true} path="/contact" component={ViewFaleConosco}/>
          <Route exact={true} path="/faq" component={ViewFaq}/>
          <Route exact={true} path="/library/bookmarks" component={ViewFavoritos}/>
          <Route exact={true} path="/library/notes" component={ViewMarcacoes}/>
          <Route exact={true} path="/library/readinglist" component={ViewListasDeLeitura}/>
          <Route exact={true} path="/library/readinglist/import" component={ViewListasDeLeitura}/>
          <Route exact={true} path="/library/readinglist/uid/:uid" component={ViewListasDeLeitura}/>
          <Route exact={true} path="/feed" component={ViewMain}/>
          <Route exact={true} path="/relatorios" component={ViewReport}/>
          <Route exact={true} path="/curso/:courseUid/:registerUid" component={ViewCourse}/>
          <Route exact={true} path="/webview/:id" component={ViewWebview}/>
          <Route exact={true} path="/player/:courseUid/:registerUid/:moduleUid/:activityUid" component={ViewPlayer}/>
          <Route exact={true} path="/commerce" component={ViewCommerce}/>
          <Route exact={true} path="/livro/:file/:reference" component={ViewLivro}/>
          <Route exact={true} path="/book/:uid" component={ViewBookDetail}/>
          <Route exact={true} path="/content/uid/:uid/detail" component={ViewBookDetail}/>
          <Route exact={true} path="/search/category/:uid/:page" component={ViewSearchCategory}/>
          <Route exact={true} path="/search/term/:page/:term" component={ViewSearchTerm}/>
          <ReaderSettings />
        </div>
      </div>
    );
  }
}

export default App;
